import 'bootstrap/dist/css/bootstrap.css';
import './main.scss'
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig, setMsalInstance } from "./authConfig";
//import unregisterServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const msalInstance = new PublicClientApplication(msalConfig);

// Set the global MSAL instance for use in acquireToken
setMsalInstance(msalInstance);

// Initialize MSAL before rendering
msalInstance.initialize().then(() => {
  root.render(
      <MsalProvider instance={msalInstance}>
          <BrowserRouter basename={baseUrl}>
              <App />
          </BrowserRouter>
      </MsalProvider>
  );

  unregister();
}).catch((error) => {
  console.error('MSAL initialization failed:', error);
});
